export * from './colors';

export const fonts = {
  serif: "'Gaegu', cursive",                  // conversation text
  sans: "'Bellefair', serif",                  // UI chrome
  handwritten: "'Bellefair', serif",             // story narration / captions
};

export const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 40,
  xxl: 64,
};

export const radius = {
  sm: 6,
  md: 12,
  lg: 20,
  xl: 32,
  panel: 14,
  bubble: 18,
  pill: 999,
};

export const shadow = {
  panel: '0 2px 16px rgba(0,0,0,0.07)',
  soft: '0 1px 6px rgba(0,0,0,0.05)',
  lift: '0 4px 24px rgba(0,0,0,0.10)',
};
